import React, { PropsWithChildren } from 'react';

import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { VegaLiteSpec } from '@atom/types/conversationalAnalytics';

import ChatPrimaryButton from '../chat/ChatPrimaryButton';

import useConversationalAnalyticsData from './hooks/useConversationalAnalyticsData';
import ConversationalAnalyticsChartError from './ConversationalAnalyticsChartError';

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    border: `1px solid ${colors.neutral.ash}`,
    borderRadius: '0.75rem',
    padding: '1.25rem',
    margin: '0.5rem 0',
  },
  title: {
    fontSize: fonts.lg,
    fontWeight: '500',
    marginTop: 0,
    marginBottom: '1rem',
    color: colors.neutral.dark,
  },
};

type ConversationalAnalyticsChartWrapperProps = PropsWithChildren<{
  spec: VegaLiteSpec;
  onExport?: () => void;
}>;

const ConversationalAnalyticsChartWrapper: React.FC<
  ConversationalAnalyticsChartWrapperProps
> = ({ spec, children, onExport }) => {
  const { xField, yField } = useConversationalAnalyticsData(spec);

  if (!xField || !yField) {
    return <ConversationalAnalyticsChartError />;
  }

  return (
    <>
      <div style={styles.wrapper}>
        {spec.title && (
          <h3 style={styles.title}>
            {typeof spec.title === 'string' ? spec.title : spec.title.text}
          </h3>
        )}
        {children}
      </div>
      {onExport && (
        <ChatPrimaryButton
          startIcon={<Icon>file_download</Icon>}
          onClick={onExport}
        >
          Export Chart
        </ChatPrimaryButton>
      )}
    </>
  );
};

export default ConversationalAnalyticsChartWrapper;
